/** Unmount private views before clearing the reactive context they depend on. */
export function useSignOut() {
  const signingOut = useState('auth-signing-out', () => false)
  const supabase = useSupabaseClient()
  const { clear: clearPrivateClientState } = usePrivateClientState()

  const signOut = async () => {
    if (signingOut.value) return
    signingOut.value = true
    try {
      // Let the application remove dashboard watchers before signOut emits
      // SIGNED_OUT and the account-change plugin clears the school context.
      await nextTick()
      const { error } = await supabase.auth.signOut()
      if (error) throw error
      await clearPrivateClientState()
      // Start a fresh public application after discarding private async state.
      // This also avoids reusing an in-flight dashboard Suspense transition.
      await navigateTo('/login', { external: true, replace: true })
    } catch (error) {
      signingOut.value = false
      throw error
    }
  }

  return { signingOut, signOut }
}
